"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _IconConstants = require("./IconConstants");

var _UIIcon = _interopRequireDefault(require("./UIIcon"));

var Outer = _styledComponents.default.span.withConfig({
  displayName: "UIIconHolder__Outer",
  componentId: "sc-8hlc1p-0"
})(["display:inline-flex;font-size:", ";line-height:1;padding:", ";transform:", ";user-select:none;position:relative;&.private-icon-circle--legacy{display:inline-flex;align-items:center;height:2em;justify-content:center;width:2em;}"], function (_ref) {
  var size = _ref.size;
  return size != null && (_IconConstants.ICON_SIZES[size] || size) + "px";
}, function (_ref2) {
  var padding = _ref2.padding;
  return padding != null && padding + "em";
}, function (_ref3) {
  var rotate = _ref3.rotate;
  return rotate != null && "rotate(" + rotate + "deg)";
});

var getIconTransform = function getIconTransform(_ref4) {
  var rotate = _ref4.rotate,
      rotateLock = _ref4.rotateLock;
  return rotate != null && !rotateLock ? "rotate(" + rotate * -1 + "deg)" : null;
};

var Icon = (0, _styledComponents.default)(function (props) {
  var __rotate = props.rotate,
      __rotateLock = props.rotateLock,
      rest = (0, _objectWithoutProperties2.default)(props, ["rotate", "rotateLock"]);
  return _react.default.createElement(_UIIcon.default, rest);
}).withConfig({
  displayName: "UIIconHolder__Icon",
  componentId: "sc-8hlc1p-1"
})(["height:1em;width:1em;margin:0.25em 0.125em 0;transform-origin:50% 38%;transform:", " translateY(-6.3%);"], getIconTransform);
var UIIconHolder = (0, _memoWithDisplayName.default)('UIIconHolder', function (_ref5) {
  var backgroundColor = _ref5.backgroundColor,
      borderColor = _ref5.borderColor,
      borderRadius = _ref5.borderRadius,
      borderStyle = _ref5.borderStyle,
      borderWidth = _ref5.borderWidth,
      color = _ref5.color,
      innerClassName = _ref5.innerClassName,
      innerStyles = _ref5.innerStyles,
      name = _ref5.name,
      rotate = _ref5.rotate,
      rotateLock = _ref5.rotateLock,
      size = _ref5.size,
      style = _ref5.style,
      verticalAlign = _ref5.verticalAlign,
      rest = (0, _objectWithoutProperties2.default)(_ref5, ["backgroundColor", "borderColor", "borderRadius", "borderStyle", "borderWidth", "color", "innerClassName", "innerStyles", "name", "rotate", "rotateLock", "size", "style", "verticalAlign"]);
  return _react.default.createElement(Outer, Object.assign({}, rest, {
    rotate: rotate,
    size: size,
    style: Object.assign({
      backgroundColor: backgroundColor,
      borderColor: borderColor,
      borderRadius: borderRadius,
      borderStyle: borderStyle,
      borderWidth: borderWidth,
      verticalAlign: verticalAlign
    }, style)
  }), _react.default.createElement(Icon, {
    className: innerClassName,
    color: color,
    name: name,
    rotate: rotate,
    rotateLock: rotateLock,
    size: size,
    style: innerStyles
  }));
});
UIIconHolder.propTypes = {
  backgroundColor: _propTypes.default.string,
  borderColor: _propTypes.default.string,
  borderRadius: _propTypes.default.string,
  borderStyle: _propTypes.default.oneOf(['solid', 'double', 'dashed', 'dotted', 'initial', 'inherit', 'unset']),
  borderWidth: _propTypes.default.number,
  verticalAlign: _propTypes.default.string,
  classname: _propTypes.default.string,
  color: _UIIcon.default.propTypes.color,
  innerClassName: _propTypes.default.string,
  name: _UIIcon.default.propTypes.name,
  padding: _propTypes.default.number,
  rotate: _propTypes.default.number,
  rotateLock: _propTypes.default.bool,
  size: _UIIcon.default.propTypes.size,
  innerStyles: _propTypes.default.object
};
UIIconHolder.defaultProps = {
  padding: 0.5,
  rotate: 0,
  borderStyle: 'solid',
  borderWidth: 0
};
var _default = UIIconHolder;
exports.default = _default;
module.exports = exports.default;